module.exports = __webpack_public_path__ + "static/Carpathian Seagull-aac72f103da7a585e765ae1d3506ba04.svg";